var _path, _path2, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0846 3.16675H7.91797C6.65819 3.16675 5.45001 3.66719 4.55921 4.55799C3.66841 5.44879 3.16797 6.65697 3.16797 7.91675V23.7501C3.16797 25.0099 3.66841 26.218 4.55921 27.1088C5.45001 27.9996 6.65819 28.5001 7.91797 28.5001H26.2688L32.1271 34.3742C32.2751 34.521 32.4505 34.6371 32.6434 34.7159C32.8364 34.7947 33.0429 34.8346 33.2513 34.8334C33.459 34.8388 33.6651 34.7954 33.853 34.7067C34.1421 34.588 34.3896 34.3863 34.5643 34.127C34.739 33.8678 34.8331 33.5627 34.8346 33.2501V7.91675C34.8346 6.65697 34.3342 5.44879 33.4434 4.55799C32.5526 3.66719 31.3444 3.16675 30.0846 3.16675ZM31.668 29.4342L28.0421 25.7926C27.8942 25.6458 27.7187 25.5297 27.5258 25.4509C27.3329 25.3721 27.1263 25.3322 26.918 25.3334H7.91797C7.49804 25.3334 7.09532 25.1666 6.79838 24.8697C6.50145 24.5727 6.33464 24.17 6.33464 23.7501V7.91675C6.33464 7.49682 6.50145 7.0941 6.79838 6.79716C7.09532 6.50023 7.49804 6.33341 7.91797 6.33341H30.0846C30.5046 6.33341 30.9073 6.50023 31.2042 6.79716C31.5012 7.0941 31.668 7.49682 31.668 7.91675V29.4342Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80469 5.80566H32.1936V31.6668L26.9158 26.389H5.80469V5.80566Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0833,
    cy: 15.8333,
    r: 1.58333,
    fill: "#2079FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0013,
    cy: 15.8333,
    r: 1.58333,
    fill: "#2079FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9154,
    cy: 15.8333,
    r: 1.58333,
    fill: "#2079FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.f2bf4fc6aa8d28993214ffde82b22f6f.svg";
export { ForwardRef as ReactComponent };